module.exports = {"tel":"+258 21 08 27 08","email":"info@quickepay.co.mz","website":"https://www.quickepay.co.mz","ekutiva_website":"https://ekutivasolutions.co.mz","address":{"country":"Moçambique","city":"Maputo","avenue":"Av. 25 de Setembro","number":"1147"},"description":"Um serviço de pagamentos online que explora carteiras móveis como a fonte principal de pagamentos"}


//////////////////
// WEBPACK FOOTER
// ./src/database/company.json
// module id = YerF
// module chunks = 0